import { render, staticRenderFns } from "./repaymentItem.vue?vue&type=template&id=45b5d12e&scoped=true"
import script from "./repaymentItem.vue?vue&type=script&lang=js"
export * from "./repaymentItem.vue?vue&type=script&lang=js"
import style0 from "./repaymentItem.vue?vue&type=style&index=0&id=45b5d12e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b5d12e",
  null
  
)

export default component.exports